export const TierTypes = {
  TICKET: 'TICKET',
  TIER: 'TIER',
  MEMBERSHIP: 'MEMBERSHIP',
  PRODUCT: 'PRODUCT',
  SERVICE: 'SERVICE',
  DONATION: 'DONATION',
};

export const AmountTypes = {
  FIXED: 'FIXED',
  FLEXIBLE: 'FLEXIBLE',
};

export default Object.values(TierTypes);
